module.exports = __webpack_public_path__ + "img/close_ico_5 (1).bb0c548c.svg";